<template>
  <div class="aqs-container">
    <img src="@/assets/aqs/aqs_img_01.jpg" />
    <div class="form-box">
      <div class="hint-label">
        您想领取哪个专业的备考资料<span>(单选)<i>*</i></span>
      </div>
      <div class="radio-wrapper">
        <el-radio-group v-model="subject">
          <el-radio :label="item.name" v-for="(item, index) in subjectList" :key="index">{{ item.name }}</el-radio>
        </el-radio-group>
      </div>
      <div class="hint-label">
        您的电话<span style="font-size: 14px">(已加密：仅领取资料使用)<i>*</i></span>
      </div>
      <div class="form-item">
        <input type="text" maxlength="15" placeholder="请输入手机号" v-model="formData.mobile" />
      </div>
      <div class="form-item" style="margin-top: 15px">
        <input type="text" maxlength="10" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="submit" @click="onsubmit">立即领课</div>
    </div>
    <img src="@/assets/aqs/aqs_img_02.jpg" />
    <img src="@/assets/aqs/aqs_img_03.jpg" />
    <img src="@/assets/aqs/aqs_img_04.jpg" />
  </div>
</template>

<script>
import { graduatePromot, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      subject: '',
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      subjectList: [
        {
          name: '煤矿安全'
        },
        {
          name: '化工安全'
        },
        {
          name: '建筑施工安全'
        },
        {
          name: '金属冶炼安全'
        },
        {
          name: '道路运输安全'
        },
        {
          name: '其他安全'
        },
        {
          name: '金属非金属矿山安全'
        }
      ],
      //发送验证码
      isCodeClickable: true
    }
  },
  methods: {
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.subject.length) {
        return this.$toast.center('请选择科目')
      }
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      const gt = new Date().getTime().toString()
      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        collegeName: '注册安全工程师',
        orign: '腾讯广点通',
        promotedAccount: '腾讯-中课-44296477-注安-职',
        remark: `用户想领取【${this.subject}】专业的备考资料`,
        fromType: '1',
        url: window.location.origin + window.location.pathname
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
        this.checkSubjects = []
      })
    }
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.aqs-container {
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
    vertical-align: bottom;
  }
  .form-box {
    padding: 0 5vw 6vw;
    .hint-label {
      font-size: 14px;
      color: rgb(127, 127, 127);
      padding-top: 10px;
      padding-bottom: 15px;
      span {
        font-size: 12px;
      }
      i {
        font-style: inherit;
        color: red;
      }
    }
    ::v-deep .el-radio-group {
      .el-radio {
        width: 40%;
        margin-bottom: 15px;
        .el-radio__inner {
          width: 16px;
          height: 16px;
        }
        .el-radio__label {
          color: #333;
        }
      }
    }
    .form-item {
      display: flex;
      padding-bottom: 6px;
      border-bottom: 1px solid #eee;
      input {
        flex: 1;
        outline: none;
        border: none;
        color: rgb(127, 127, 127);
        font-size: 14px;
      }
      .code {
        color: rgb(127, 127, 127);
        font-size: 14px;
      }
    }
    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60%;
      margin: 15px auto 0;
      padding: 12px 0;
      color: #fff;
      font-weight: bold;
      background: rgb(65, 135, 255);
    }
  }
}
</style>
